import brandAwsEc2 from './images/brand-aws-ec2.svg';
import brandAzure from './images/brand-azure.svg';
import brandDropbox from './images/brand-dropbox.svg';
import brandEntraId from './images/brand-entra-id.svg';
import brandGithub from './images/brand-github.svg';
import brandGoogleWorkspace from './images/brand-google-workspace.png';
import brandHibob from './images/brand-hibob.svg';
import brandOffice365 from './images/brand-office365.svg';
import brandOktaInk from './images/brand-okta-ink.svg';
import brandOkta from './images/brand-okta.svg';
import brandOnedrive from './images/brand-onedrive.svg';
import brandS3 from './images/brand-s3.svg';
import brandSharepoint from './images/brand-sharepoint.svg';
import brandSlack from './images/brand-slack.svg';
import brandWorkday from './images/brand-workday.svg';

const BRAND_REGISTRY = {
  office365: { asset: brandOffice365, label: 'Office 365' },
  'google-workspace': { asset: brandGoogleWorkspace, label: 'Google Workspace' },
  'entra-id': { asset: brandEntraId, label: 'Microsoft Entra ID' },
  // ponytail: the Figma export is the greyed (#8D8D8D) Okta wheel — the only
  // state the design shows. Re-export in brand blue if Okta ever goes live.
  okta: { asset: brandOkta, label: 'Okta' },
  // The dark (#4D1E1E) Okta wheel from the define-environment tiles (Figma
  // `2754:8369`), where Okta IS selectable — the greyed `okta` above stays for
  // the sign-in step's disabled pill.
  'okta-ink': { asset: brandOktaInk, label: 'Okta' },
  hibob: { asset: brandHibob, label: 'HiBob' },
  sharepoint: { asset: brandSharepoint, label: 'Microsoft SharePoint' },
  github: { asset: brandGithub, label: 'GitHub' },
  dropbox: { asset: brandDropbox, label: 'Dropbox' },
  workday: { asset: brandWorkday, label: 'Workday' },
  slack: { asset: brandSlack, label: 'Slack' },
  azure: { asset: brandAzure, label: 'Microsoft Azure' },
  'aws-ec2': { asset: brandAwsEc2, label: 'Amazon EC2' },
  s3: { asset: brandS3, label: 'Amazon S3' },
  onedrive: { asset: brandOnedrive, label: 'OneDrive' },
} as const;

export type BrandIconId = keyof typeof BRAND_REGISTRY;

export const brandIcons: Readonly<Record<BrandIconId, string>> = Object.fromEntries(
  Object.entries(BRAND_REGISTRY).map(([id, { asset }]) => [id, asset])
) as Readonly<Record<BrandIconId, string>>;

export const BRAND_LABELS: Readonly<Record<BrandIconId, string>> = Object.fromEntries(
  Object.entries(BRAND_REGISTRY).map(([id, { label }]) => [id, label])
) as Readonly<Record<BrandIconId, string>>;
